import React from 'react';
import { observer } from 'mobx-react';
import { AppUI, ExerciseUI } from '@seedlang/state';
import { isBlank, isPresent } from '@seedlang/utils';
import Spinner from 'components/spinner';
import styled from '@emotion/styled';
import YoutubeThumbnailPlayer from 'components/worksheet/youtube_thumbnail_player';
import PodcastPlayer from 'components/worksheet/podcast_player';
import WorksheetDescription from 'components/worksheet/worksheet_description';
import { observable, computed } from 'mobx';
import eventParamsHelper from 'utils/event_params_helper';

const TopSection = styled.div`
  display: flex;
  @media (max-width: 999px) {
    flex-direction: column;
  }
  gap: 10px;
`;

const MediaSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  visibility: ${props => props.visibility};
  background: white;
  border-radius: 10px;
  width: ${props => props.podcastPlayer ? '' : '580px'};
  flex-shrink: 0;
  @media (max-width: 999px) {
    width: 100%;
  }
`;

const WorksheetDescriptionWrapper = styled.div`
  height: auto;
  padding: 20px;
  background: white;
  border-radius: 10px;
  flex: 1
`;

@observer
class WorksheetInfo extends React.Component {

  @observable showModal = false;

  @computed get showYoutubeVideo() {
    // in ios safari the iframe will always be on top of the modal
    return !(AppUI.layout.ios && AppUI.layout.isSafari && this.showModal);
  }

  @computed get showPodcastPlayer() {
    return !AppUI.layout.isMobile && ExerciseUI.hasWorksheet && isPresent(ExerciseUI.worksheet?.podcastEpisode) && isBlank(ExerciseUI.formattedYoutubeUrl);
  }

  handleVideoThumbnailClick = () => {
    if (AppUI.siteIsMemrev) {
      AppUI.createEvent('memrev - click YouTube video', eventParamsHelper({
        worksheet_id: ExerciseUI.worksheet?.id,
        youtube_video_id: ExerciseUI.worksheet?.youtubeVideoId,
      }));
    }
  }

  render() {
    return (
      <TopSection>
          {
            !ExerciseUI.hasWorksheet &&
            <Spinner
              background={AppUI.site.accentColor || '#868686'}
            />
          }
          {
            ExerciseUI.hasWorksheet &&
              <WorksheetDescriptionWrapper>
                <WorksheetDescription
                  borderRadius={this.props.borderRadius}
                  showModal={this.showModal}
                  onModalChange={show => this.showModal = show}
                />
              </WorksheetDescriptionWrapper>
          }
          {
            this.showPodcastPlayer &&
              <MediaSection podcastPlayer>
                <PodcastPlayer
                  hasAccess={ExerciseUI.worksheet?.accessStatus?.hasAccess}
                  noAccessReason={ExerciseUI.worksheet?.accessStatus?.reason}
                  podcast={ExerciseUI.worksheet?.podcastEpisode?.podcast}
                  podcastEpisode={ExerciseUI.worksheet?.podcastEpisode}
                  borderRadius={this.props.borderRadius}
                />
              </MediaSection>
          }
          {
            ExerciseUI.hasWorksheet && isPresent(ExerciseUI.formattedYoutubeUrl) &&
            <MediaSection id='video-player' visibility={this.showYoutubeVideo ? 'visible' : 'hidden'}>
              <YoutubeThumbnailPlayer
                allowFloating={!ExerciseUI.exercise?.formattedDescriptionVideo}
                hasAccess={ExerciseUI.worksheet?.accessStatus?.hasAccess}
                url={ExerciseUI.formattedYoutubeUrl}
                thumbnailUrl={ExerciseUI.worksheet?.imageUrl}
                placeholderImageUrl={ExerciseUI.worksheet?.image?.url}
                podcastEpisode={ExerciseUI.worksheet?.podcastEpisode}
                durationSeconds={ExerciseUI.worksheet?.videoDurationSeconds}
                borderRadius={this.props.borderRadius}
                onPlay={this.handleVideoThumbnailClick}
              />
            </MediaSection>
          }
        </TopSection>
    );
  }
}

export default WorksheetInfo;
